import React from "react"
import { Link } from "gatsby"

const MoreBlog = () => (
    <div className="container-fluid color-four mt-3">
        <div className="row align-items-center p-4">
            <div className="col">
                <Link to="/blog" className="text-decoration-none">
                    <p className="med-text-color-bg text-center m-0">See more updates.</p>
                </Link>
            </div>
        </div>
    </div>
)

export default MoreBlog